// extracted by mini-css-extract-plugin
module.exports = {"root":"Badge_root__3tR1p"};